// Lightweight list of report slugs that have long-form detail pages.
// Extracted from report-details.ts so pages that only need to know "does this
// report have a detail page?" (homepage, cards, etc.) do NOT pull the full
// ~70 KiB report-details module into their bundle.
//
// Keep in sync with src/content/report-details.ts.
export const REPORT_DETAIL_SLUGS: ReadonlySet<string> = new Set([
  "industry-spotlight-banking-in-bulgaria",
  "industry-spotlight-pharma-in-bulgaria",
  "back-to-school-2026",
  "e-health-age-and-regional-patterns-in-bulgaria",
  "from-energy-shock-to-energy-transition",
  "media-in-southeast-europe-common-narratives-in-nato-members",
  "ai-in-public-discourse",
  "bulgarian-banking-and-the-euro-transition",
  "renewable-energy-in-the-southeast-europe-region",
  "the-most-media-visible-founders-ventures-in-bulgaria",
  "the-boycott-of-retail-chains-in-bulgaria",
  "competitive-analysis-of-the-pharma-industry-2023-supplements-vol-2",
  "competitive-analysis-pharma-industry-2023-pharmaceuticals",
  "analysis-supermarket-industry-in-bulgaria",
  "media-intelligence-banking-sector-bulgaria",
  "communications-challenges-in-the-banking-industry",
  "communications-challenges-in-the-retail-sector",
  "communications-challenges-in-the-pharma-industry",
  "bulgarian-banking-industry-report",
]);